import React from 'react';
import { ReactComponent as BroadcasterIcon } from '../images/kickbadges/broadcaster.svg';
import { ReactComponent as ModeratorIcon } from '../images/kickbadges/moderator.svg';
import { ReactComponent as GiftedIcon } from '../images/kickbadges/gifted-1.svg';
import { ReactComponent as FounderIcon } from '../images/kickbadges/founder.svg';
import { ReactComponent as BotIcon } from '../images/kickbadges/bot.svg';
import { ReactComponent as StaffIcon } from '../images/kickbadges/staff.svg';
import { ReactComponent as VerifiedIcon } from '../images/kickbadges/verified.svg';
import { ReactComponent as SubscriberIcon } from '../images/kickbadges/subscriber.svg';

// Map badge types to SVG components
export const badgeMap = {
  broadcaster: <BroadcasterIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 2 }} />,
  moderator: <ModeratorIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 2 }} />,
  gifted: <GiftedIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 2 }} />,
  founder: <FounderIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 2 }} />,
  bot: <BotIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 2 }} />,
  staff: <StaffIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 2 }} />,
  verified: <VerifiedIcon viewBox="0 0 32 32" style={{ width: 18, height: 18, marginRight: 2 }} />
};

export const ICON_BADGE_TYPES = ["broadcaster", "moderator", "gifted", "founder", "bot", "staff", "verified"];

export function renderBadges(sender, channelSubBadges) {
  if (!sender?.identity?.badges || sender.identity.badges.length === 0) return null;

  return sender.identity.badges.map((badge, i) => {
    if (!badge.type) return null;

    if (ICON_BADGE_TYPES.includes(badge.type)) {
      return React.cloneElement(badgeMap[badge.type], { key: i, title: badge.text });
    } else if (badge.type === "subscriber") {
      // If channel has custom sub badges, try to use them
      if (channelSubBadges && channelSubBadges.length > 0 && badge.count) {
        // Try to find exact match for month count, fallback to 1-month badge
        const subBadge = channelSubBadges.find((b) => b.months === badge.count) ||
                        channelSubBadges.find((b) => b.months === 1);
        if (subBadge) {
          return (
            <img
              key={i}
              src={subBadge.badge_image.src}
              alt={`${badge.count}-Month Subscriber`}
              title={`${badge.count}-Month Subscriber`}
              className="badges"
            />
          );
        }
      }

      // Fallback to default subscriber badge if no channel badges or no match found
      return (
        <SubscriberIcon
          key={i}
          viewBox="0 0 32 32"
          style={{ width: 18, height: 18, marginRight: 2 }}
          title={badge.count ? `${badge.count}-Month Subscriber` : 'Subscriber'}
        />
      );
    }

    return null;
  });
}
